import { useEffect, useState } from 'react';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/fromEvent';

interface Output {
    togglePopup: () => void;
    hasOpenedPopup: boolean;
}

const useUpdateSettings = (): Output => {
    const [hasOpenedPopup, setHasOpenedPopup] = useState<boolean>(false);

    const togglePopup = () => {
        setHasOpenedPopup(() => !hasOpenedPopup);
    };

    useEffect(() => {
        if (!hasOpenedPopup) return;

        const closeEvents: Subscription = Observable.fromEvent(
            document,
            'click'
        ).subscribe(() => {
            setHasOpenedPopup(false);
        });

        return () => closeEvents.unsubscribe();
    }, [hasOpenedPopup]);

    return {
        togglePopup,
        hasOpenedPopup,
    };
};

export default useUpdateSettings;
